import React, { useEffect } from 'react';
import { AnnouncementEvent, MARKETING_ANNOUNCEMENT_VIEWED, analytics } from '../../helpers/analytics';
import { AnnouncementCategory, AnnouncementLevel } from './common';

type LocalAnnouncementTagProps = {
	title: string;
	icon: React.ReactNode;
	category: AnnouncementCategory,
	tableId: string
};

export const LocalAnnouncementTag = ({ title, icon, category, tableId }: LocalAnnouncementTagProps) => {

	useEffect(() => {
		analytics.track(MARKETING_ANNOUNCEMENT_VIEWED, {
			location: 'Inventory Carousel',
			level: AnnouncementLevel.LOCAL,
			message: title,
			type: category,
			tableId: tableId
		} satisfies AnnouncementEvent);
	}, []);

	return (
		<div className="z-10 inline-flex gap-1 rounded-2xl bg-carsousel-buttons backdrop-blur-md items-center justify-center border border-tablz-med-gray-4 py-2 px-3 ml-auto m-2">
			{icon}
			<span className="font-lora text-sm leading-[21px]">{title}</span>
		</div>
	);
};
